
export const CLAIM_CORRECTION_URL = {
    PENDING_CLAIMS: "claims/claimsonhold",
    PENDING_CLAIMS_BY_TIMELINE: "claims/claimsbytimeliness",
    UPDATE_CLAIM: "claims",
    GET_CLAIMCORRECTIONSTATUSLIST: "claimCorrectionStatuslookup",
    GET_MYTEAM_CLAIMS : "claims/getMyTeamClaims",
    GET_USER_ROLE : "user/role",
    VALIDATE_PROCEDURE_CODE: "claims/validateProcedureCode",
    VALIDATE_DIAGNOSIS_CODE: "claims/validateDiagnosisCode",
    GET_CARRIER_LIST : "claims/fetchCarrierList",
    ICDCODES:"icdcodes/autocomplete",
    PROCEDURECODE:"procedurecodes/autocomplete",
    DASHBOARD_METRICS:"dashboard/metrics",
    GET_UAER_STORAGE_PREFERENCE:"preferences",
    UPDATE_UAER_STORAGE_PREFERENCE:"preferences",
    GET_WRITEOFFAMOUNT :"getWriteOffAmount",
    TRAINING_MATERIAL: typeof process.env.REACT_APP_TRAINING_MATERIAL !== 'undefined' ? process.env.REACT_APP_TRAINING_MATERIAL : "",
    EYEFINITY_EEHR :  typeof process.env.REACT_APP_EYEFINITY_EEHR !== 'undefined' ? process.env.REACT_APP_EYEFINITY_EEHR : "",
    ACUITY_POS :  typeof process.env.REACT_APP_ACUITY_POS !== 'undefined' ? process.env.REACT_APP_ACUITY_POS : "",
    ENCOMPASS_POS :  typeof process.env.REACT_APP_ENCOMPASS_POS !== 'undefined' ? process.env.REACT_APP_ENCOMPASS_POS : "",  
    CLINICAL_MEDU: typeof process.env.REACT_APP_CLINICAL_MEDU !== 'undefined' ? process.env.REACT_APP_CLINICAL_MEDU : "",
    AMEND_IPAD: typeof process.env.REACT_APP_AMEND_IPAD !== 'undefined' ? process.env.REACT_APP_AMEND_IPAD : "",
    AMEND_DESKTOP: typeof process.env.REACT_APP_AMEND_DESKTOP !== 'undefined' ? process.env.REACT_APP_AMEND_DESKTOP : "",
    REORDERING_CHIEF_COMPLAINTSPDF: typeof process.env.REACT_APP_ORDERING_CHIEF_COMPLAINTS_PDF !== 'undefined' ? process.env.REACT_APP_ORDERING_CHIEF_COMPLAINTS_PDF : "",
    MVC_SOP_USING_CLINICAL_CORRECTIONS_TOOL: typeof process.env.REACT_APP_MVC_SOPUSING_CLINICAL_CORRECTIONS_TOOL !== 'undefined' ? process.env.REACT_APP_MVC_SOPUSING_CLINICAL_CORRECTIONS_TOOL : "",
    CLINICAL_CORRECTION_SRESOUR_CECENTER : typeof process.env.REACT_APP_CLINICAL_CORRECTIONS_RESOURCE_CENTER !== 'undefined' ? process.env.REACT_APP_CLINICAL_CORRECTIONS_RESOURCE_CENTER : "",
    CLINICAL_CORRECTIONS_FAQ : typeof process.env.REACT_APP_CLINICAL_CORRECTIONS_FAQ !== 'undefined' ? process.env.REACT_APP_CLINICAL_CORRECTIONS_FAQ : "",
};
